/**
 * MD5 helpers — ported 1:1 from
 * packages/amgbaccarat_v2/lib/core/utils/md5_helper.dart.
 *
 * Two variants are used by the Baccarat API service
 * (baccarat_api_service.dart:65-73, 117-125, 231-241):
 *   - generateBalanceMd5 — used for openGame / balance / placeBet
 *       md5(agentId + gameKey + userName)
 *   - generateInfoMd5    — used for getInfo
 *       md5(userName)
 */
import { md5 } from 'js-md5';

export function md5Hex(input: string): string {
  return md5(input);
}

export function generateBalanceMd5(
  agentId: string,
  gameKey: string,
  userName: string,
): string {
  return md5Hex(`${agentId}${gameKey}${userName}`);
}

export function generateInfoMd5(userName: string): string {
  return md5Hex(userName);
}
